__webpack_require__.p = "https://static-public-web-files.my.telia.lt/_next/";